<div class="_media-fullscreen">
  <button class="icon-close" (click)="closeModal()"></button>
</div>
<div class="iframe__container">
  <!-- <iframe src="assets/e-catalog/index.html" width="100%" height="100%"></iframe> -->
  <iframe [src]="applicationData.convertFilePath(environment.BASE + '/api/uploads/e-catalog/index.html') | safeUrl" width="100%" height="100%"></iframe>
</div>
